<template>
    <div class="box">
        <law-info-card
            @onBind="handleBind"
        ></law-info-card>
        <!-- 权益卡片列表 -->
        <div class="card-list">
            <privilege-list
                :vip-info="vipInfo"
                :privilege-list="privilegeConfigList"
            ></privilege-list>
        </div>
        <div
            class="service"
        >
            <!-- 权益对比表格:非正式会员展示 -->
            <privilege-compare
                :vip-info="vipInfo"
            ></privilege-compare>
        </div>
        <bind-vip-code
            :show="isBindShow"
            title="绑定百度律师VIP会员"
            :is-firm="0"
            placeholder="请输入律师会员码"
            @closeDialog="isBindShow = false"
            @getVipInfo="getVipPrivilegeInfo"
        />
        <veui-lightbox
            overlay-class="law-service-lightbox"
            :open.sync="openPic"
            :datasource="items"
            :wrap="false"
            indicator="none"
        />
    </div>
</template>

<script>
import {Lightbox} from 'veui';
import {mapState, mapActions} from 'vuex';
import mixinajax from '@/mixins/ajax';
import LawInfoCard from '@/components/lawInfoCard';
import BindVipCode from '@/components/bind-vip-code/bind-vip-code';
import PrivilegeList from './privilege-list';
import PrivilegeCompare from './privilege-compare';
import privilegeIcon from '../privilege.js';
/**
 * @file law-serve.vue
 * @author baoleilei
 * @desc 会员服务
 */
const url = {
    authorize: '/bp/api/vip/genvip',
    privilege: '/bp/api/user/privilege/config_new'
};

export default {
    name: 'lawservice',
    mixins: [mixinajax],
    components: {
        'law-info-card': LawInfoCard,
        'veui-lightbox': Lightbox,
        'bind-vip-code': BindVipCode,
        'privilege-list': PrivilegeList,
        'privilege-compare': PrivilegeCompare
    },
    data() {
        return {
            isBindShow: false,
            openPic: false,
            items: [
                {
                    src: 'https://law-smartapp.cdn.bcebos.com/product-intro.jpg',
                    alt: '',
                    desc: ''
                }
            ],
            privilegeConfigList: []
        };
    },
    created() {
        this.getUserInfoNew();
        this.getVipPrivilegeInfo();
    },
    methods: {
        ...mapActions({
            getUserInfoNew: 'lawStore/getUserInfoNew',
            getVipInfo: 'lawStore/getVipInfo'
        }),
        // 刷新会员和权益信息
        getVipPrivilegeInfo() {
            this.getVipInfo();
            this.getPrivilegeConfig();
        },
        // 获取权益配置
        getPrivilegeConfig() {
            const params = {
                client_type: 'pc'
            };
            this.$http.get(url.privilege, {params}).then(res => {
                if (+res?.code === 0) {
                    const {privilege_config_list} = res.data || {};
                    this.privilegeConfigList = privilege_config_list || [];
                }
                else {
                    this.$normalizeResponseError(res);
                }
            });
        },
        // 整合权益状态和权益列表文案配置
        formatPrivilegeList() {
            const configList = this.privilegeConfigList;
            const {privilege_info = {}, vipStatusName} = this.vipInfo;
            const configInfo = privilegeIcon[vipStatusName + 'IconList'] || privilegeIcon.noVipIconList;
            let res = configList || [];
            res = res.map(item => {
                let extData = {
                    // 是否拥有权益
                    has: 0,
                    // 是否激活权益 默认激活
                    isActive: 1
                };
                // 拥有该权益
                if (+configInfo[item.name]) {
                    extData.has = 1;
                    // 检查5865激活状态
                    if (
                        item.name === 'show5865'
                        && !+privilege_info.show_5865
                    ) {
                        extData.isActive = 0;
                    }
                }
                return {
                    ...item,
                    ...extData
                };
            });
            return res;
        },
        // 绑码
        handleBind() {
            this.$wywLog.send({
                serverId: 16844,
                area: 'pc-bm-btn',
                action: 'click'
            });
            this.isBindShow = true;
        }
    },
    computed: {
        ...mapState({
            userInfoNew: state => state.lawStore.userInfoNew,
            vipInfo: state => state.lawStore.vipInfo
        }),
        privilegeList() {
            return this.formatPrivilegeList();
        }
    },
    watch: {
        vipInfo: {
            handler(val) {
                if (val) {
                    this.$wywLog.addKey({
                        vipStatusName: val.vipStatusName || ''
                    });
                    this.$wywLog.send({
                        serverId: 16844,
                        area: 'pc-hyfw',
                        action: 'pv'
                    });
                }
            }
        }
    }
};
</script>

<style lang="less" scoped>
/deep/ .veui-dialog-content-head-title {
    font-size: 20px;
}

/deep/ .veui-dialog-content {
    width: 440px;
}

/deep/ .veui-input-after {
    display: none;
}
// .service
/deep/ .ivu-input {
    line-height: 32px !important;
}

.law-service-lightbox {
    /deep/ .veui-lightbox-item-content {
        overflow: auto;

        img {
            max-height: 2500px;
            height: 2500px;
        }
    }
}

.card-list {
    margin-top: 24px;
    background: #fff;
    border-radius: 8px;
    padding: 1px 30px 20px 30px;
}

.service {
    margin-top: 24px;
    background: #fff;
    border-radius: 8px;
    padding: 1px 30px 50px 30px;
}
</style>
